import { useEffect, useState } from "react";
import Lenis from "lenis";
import { dict } from "./i18n";
import { LangContext } from "./site-context";
import Header from "./components/site/Header";
import Hero from "./components/site/Hero";
import Marquee from "./components/site/Marquee";
import Services from "./components/site/Services";
import Fleet from "./components/site/Fleet";
import Heritage from "./components/site/Heritage";
import Payments from "./components/site/Payments";
import Contact from "./components/site/Contact";
import Footer from "./components/site/Footer";

function App() {
  const [lang, setLang] = useState(() => localStorage.getItem("tlh-lang") || "pt");

  useEffect(() => {
    localStorage.setItem("tlh-lang", lang);
    document.documentElement.lang = lang === "pt" ? "pt-PT" : "en";
  }, [lang]);

  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    window.__lenis = lenis;
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <LangContext.Provider value={{ lang, setLang, t: dict[lang] }}>
      <div className="min-h-screen bg-[#0a1120] text-slate-200 ff-body">
        <div className="grain-overlay" aria-hidden="true" />
        <Header />
        <main>
          <Hero />
          <Marquee />
          <Services />
          <Fleet />
          <Heritage />
          <Payments />
          <Contact />
        </main>
        <Footer />
      </div>
    </LangContext.Provider>
  );
}

export default App;
